import { Endpoints, generateAxios } from '@matap/shared';
import { generateQuery } from './create-hooks';

export const useTermsAndConditions = generateQuery(Endpoints.serverConfigs.user.tac, (endpoint, payload) => ({
  queryKey: ['useTermsAndConditions'],
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
}));
